import React, {useEffect, useState} from 'react';
import {Helmet} from 'react-helmet';
import DashboardHeader from '../../components/DashboardHeader';
import Wrapper from '../../components/Wrapper';
import {useTranslation} from '../../hooks/useTranslation';
import './index.scss';
import Input from '../../components/Input';
import InactiveRow from '../../components/InactiveRow';
import Select from 'react-select';
import {useGetRevisions} from '../EquipmentType/model/revisions/getRevisions';
import {
  useGetTimezonesQuery,
  useInviteFboMutation,
  useLazyAgencyInactiveQuery,
  useLazyCorporateListQuery,
} from '../../store/builder/inspections.api';
import Modal from '../../components/Modal';
import {validationEmail} from '../../global/validate';
import {toast} from 'react-toastify';
import {useDispatch} from 'react-redux';
import AgencyDeleteModal from '../../components/AgencyDeleteModal';
import {useDebounce} from '../LogSheets/hooks';
import CustomPaginate from '../../components/PaginateComponent';
import useLoader from '../../global/UseLoadingHandler';

const AgencyInactive = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [list, setList] = useState(null);
  const [search, setSearch] = useState('');
  const [currentItem, setCurrentItem] = useState(null);
  const [createModalStatus, setCreateModalStatus] = useState(false);
  const [cropper, setCropper] = useState();
  const [imageBlob, setImageBlob] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [chosenPhoto, setChosenPhoto] = useState(null);
  const [photo, setPhoto] = useState(null);
  const [inviteModal, setInviteModal] = useState(false);
  const [email, setEmail] = useState('');
  const [deleteModal, setDeleteModal] = useState(false);
  const debouncedSearchValue = useDebounce(search, 500);

  // Filter states
  const [inspectionsRevisionFilter, setInspectionsRevisionFilter] =
    useState(null);
  const [corporateIdFilter, setCorporateIdFilter] = useState(null);
  const [inspectionEnabledFilter, setInspectionEnabledFilter] = useState(null);
  const [customInspectionsEnabledFilter, setCustomInspectionsEnabledFilter] =
    useState(null);

  // Filter options
  const enabledOptions = [
    {value: '', label: t('agencyInactive.filters.all')},
    {value: 'true', label: t('agencyInactive.filters.on')},
    {value: 'false', label: t('agencyInactive.filters.off')},
  ];

  const [getRevisions, revisionOptions] = useGetRevisions();

  const [
    getAgency,
    {
      data: getAgencyData,
      isLoading: getAgencyIsLoading,
      isError: getAgencyIsError,
      error: getAgencyError,
      isSuccess: getAgencyIsSuccess,
    },
  ] = useLazyAgencyInactiveQuery();

  const {
    data: timezonesData,
    error: timezonesError,
    isLoading: timezonesIsLoading,
    isSuccess: timezonesIsSuccess,
    isError: timezonesIsError,
  } = useGetTimezonesQuery();

  const [
    getCorporateList,
    {
      data: corporateListData,
      error: corporateListError,
      isFetching: corporateListIsLoading,
      isSuccess: corporateListIsSuccess,
      isError: corporateListIsError,
    },
  ] = useLazyCorporateListQuery();

  const [
    invite,
    {
      data: inviteData,
      isLoading: inviteIsLoading,
      isError: inviteIsError,
      error: inviteError,
      isSuccess: inviteIsSuccess,
    },
  ] = useInviteFboMutation();

  useLoader([getAgencyIsLoading, corporateListIsLoading, inviteIsLoading]);

  useEffect(() => {
    if (inviteIsSuccess) {
      toast.success(t('agencyInactive.messages.inviteSuccess'));
      setInviteModal(false);
    }
    if (inviteIsError || getAgencyIsError) {
      toast.error(inviteError?.data?.email[0]);
    }
  }, [inviteIsSuccess, inviteIsError, getAgencyIsError, getAgencyIsSuccess]);

  useEffect(() => {
    if (createModalStatus) {
      document.querySelector('html').style.overflow = 'hidden';
    } else {
      document.querySelector('html').style.overflow = 'visible';
    }
  }, [createModalStatus]);

  useEffect(() => {
    getAgency({
      page: currentPage,
      search: debouncedSearchValue,
      inspections_revision: inspectionsRevisionFilter?.value || '',
      corporate_id: corporateIdFilter?.value || '',
      inspection_enabled: inspectionEnabledFilter?.value || '',
      custom_inspections_enabled: customInspectionsEnabledFilter?.value || '',
    });
  }, [
    currentPage,
    debouncedSearchValue,
    inspectionsRevisionFilter,
    corporateIdFilter,
    inspectionEnabledFilter,
    customInspectionsEnabledFilter,
  ]);

  useEffect(() => {
    getCorporateList({status: 'active'});
  }, []);

  useEffect(() => {
    getRevisions(false, true);
  }, []);

  useEffect(() => {
    if (getAgencyData) {
      setList(
        getAgencyData?.data?.map(item => ({...item, action_status: false})),
      );
    }
  }, [getAgencyData]);

  const getAgencies = () => {
    getAgency({
      page: currentPage,
      search: debouncedSearchValue,
      inspections_revision: inspectionsRevisionFilter?.value || '',
      corporate_id: corporateIdFilter?.value || '',
      inspection_enabled: inspectionEnabledFilter?.value || '',
      custom_inspections_enabled: customInspectionsEnabledFilter?.value || '',
    });
  };

  function base64ToBlob(base64Data) {
    const contentType = base64Data.substring(5, base64Data.indexOf(';'));
    const byteCharacters = atob(
      base64Data.substring(base64Data.indexOf(',') + 1),
    );
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: contentType});
  }

  const getCropData = () => {
    if (typeof cropper !== 'undefined') {
      const image = base64ToBlob(cropper.getCroppedCanvas().toDataURL());
      setShowModal(false);
      document.querySelector('.modal-fbo').style.display = 'flex';
      setPhoto(cropper.getCroppedCanvas().toDataURL());
      setImageBlob(image);
    }
  };
  const handlePageClick = page => {
    setCurrentPage(page.selected + 1);
    window.scrollTo(0, 0);
  };

  const handleEmail = e => {
    setEmail(e.target.value);
  };
  const handleSubmitInvite = () => {
    if (validationEmail(email)) {
      invite({email: email, role_id: 2});
    } else {
      toast.error(t('agencyInactive.messages.enterCorrectEmail'));
    }
  };

  return (
    <Wrapper>
      <Helmet>
        <title>{t('agencyInactive.pageTitle')}</title>
      </Helmet>
      <DashboardHeader
        title={t('agencyInactive.title')}
        showBtn={true}
        type='agancy-trial'
        action={() => setInviteModal(true)}
        secondAction={() => setCreateModalStatus(true)}
      />
      {createModalStatus && (
        <Modal
          title={t('agencyInactive.modals.createFbo.title')}
          currentItem={currentItem}
          setCurrentItem={setCurrentItem}
          setShowModal={setShowModal}
          setChosenPhoto={setChosenPhoto}
          photo={photo}
          setCreateModalStatus={setCreateModalStatus}
          imageBlob={imageBlob}
          setPhoto={setPhoto}
          type='agancy'
          exit={() => {
            setCreateModalStatus(false);
            setPhoto(null);
            setImageBlob(null);
            setCurrentItem(null);
          }}
          getAgencies={getAgencies}
          timezones={timezonesData?.data?.map(item => ({
            value: item,
            label: item,
          }))}
        />
      )}
      {inviteModal && (
        <div className='modal'>
          <div className='modal__content'>
            <div className='modal__content-head'>
              <p>{t('agencyInactive.modals.inviteFbo.title')}</p>
              <img
                className='modal__content-exit'
                src='/assets/icons/close.svg'
                alt='close'
                onClick={() => setInviteModal(false)}
              />
            </div>
            <div className={`modal__content-body`}>
              <Input
                containerWidth={'100%'}
                id='enail'
                name='emal'
                placeholder={t('agencyInactive.modals.inviteFbo.emailPlaceholder')}
                label={t('agencyInactive.modals.inviteFbo.email')}
                type={'email'}
                onChange={handleEmail}
                defaultValue=''
              />
            </div>
            <div className='modal__content-bottom'>
              <button className='close' onClick={() => setInviteModal(false)}>
                {t('actions.cancel')}
              </button>
              <button className='save' onClick={handleSubmitInvite}>
                {t('agencyInactive.modals.inviteFbo.sendLink')}
              </button>
            </div>
          </div>
          <div
            className='modal__bg'
            onClick={() => setInviteModal(false)}
          ></div>
        </div>
      )}
      {deleteModal && (
        <AgencyDeleteModal
          exit={() => setDeleteModal(false)}
          getAgencies={getAgencies}
          currentFBO={currentItem}
        />
      )}
      <div className='inactive inspections'>
        <div className='inactive__filters'>
          <Input
            bg={'white'}
            maxwidth={300}
            type='text'
            placeholder={t('agencyInactive.searchPlaceholder')}
            name='trial__search'
            defaultValue=''
            image={'/assets/icons/search.svg'}
            onChange={e => {
              setCurrentPage(1);
              setSearch(e.target.value);
            }}
            customStyles={{
              marginTop: 10,
            }}
          />
          <Select
            placeholder={t('agencyInactive.filters.inspectionsRevision')}
            options={revisionOptions}
            isClearable
            value={inspectionsRevisionFilter}
            onChange={setInspectionsRevisionFilter}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                borderRadius: 8,
                minWidth: 200,
                height: 42,
              }),
              placeholder: baseStyles => ({
                ...baseStyles,
                color: '#9CA3AF',
                fontSize: '14px',
                fontWeight: 400,
              }),
              singleValue: baseStyles => ({
                ...baseStyles,
                color: '#718096',
                fontSize: '14px',
              }),
            }}
          />
          <Select
            placeholder={t('agencyInactive.filters.corporateId')}
            options={corporateListData?.map(item => ({
              value: item?.id,
              label: item?.title,
            }))}
            isClearable
            value={corporateIdFilter}
            onChange={setCorporateIdFilter}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                borderRadius: 8,
                minWidth: 200,
                height: 42,
              }),
              placeholder: baseStyles => ({
                ...baseStyles,
                color: '#9CA3AF',
                fontSize: '14px',
                fontWeight: 400,
              }),
              singleValue: baseStyles => ({
                ...baseStyles,
                color: '#718096',
                fontSize: '14px',
              }),
            }}
          />
          <Select
            placeholder={t('agencyInactive.filters.inspectionEnabled')}
            options={enabledOptions}
            isClearable
            value={inspectionEnabledFilter}
            onChange={setInspectionEnabledFilter}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                borderRadius: 8,
                minWidth: 200,
                height: 42,
              }),
              placeholder: baseStyles => ({
                ...baseStyles,
                color: '#9CA3AF',
                fontSize: '14px',
                fontWeight: 400,
              }),
              singleValue: baseStyles => ({
                ...baseStyles,
                color: '#718096',
                fontSize: '14px',
              }),
            }}
          />
          <Select
            placeholder={t('agencyInactive.filters.customInspectionsEnabled')}
            options={enabledOptions}
            isClearable
            value={customInspectionsEnabledFilter}
            onChange={setCustomInspectionsEnabledFilter}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                borderRadius: 8,
                minWidth: 200,
                height: 42,
              }),
              placeholder: baseStyles => ({
                ...baseStyles,
                color: '#9CA3AF',
                fontSize: '14px',
                fontWeight: 400,
              }),
              singleValue: baseStyles => ({
                ...baseStyles,
                color: '#718096',
                fontSize: '14px',
              }),
            }}
          />
        </div>
        <div className='inactive__box'>
          <div className='inactive__table'>
            <div className='inactive__table-head'>
              <div className='inactive__table-th'>{t('agencyInactive.tableHeaders.id')}</div>
              <div className='inactive__table-th'>{t('agencyInactive.tableHeaders.name')}</div>
              <div className='inactive__table-th'>{t('agencyInactive.tableHeaders.airportId')}</div>
              <div className='inactive__table-th'>{t('agencyInactive.tableHeaders.timezone')}</div>
              <div className='inactive__table-th'>{t('agencyInactive.tableHeaders.corporate')}</div>
              <div className='inactive__table-th'>{t('agencyInactive.tableHeaders.logo')}</div>
              <div className='inactive__table-th'>{t('agencyInactive.tableHeaders.invitedDate')}</div>
              <div className='inactive__table-th'>{t('agencyInactive.tableHeaders.trialStartDate')}</div>
              <div className='inactive__table-th'>{t('agencyInactive.tableHeaders.inactiveDate')}</div>
              <div className='inactive__table-th'>{t('agencyInactive.tableHeaders.action')}</div>
            </div>
            {list?.length > 0 ? (
              list?.map(inactive => (
                <InactiveRow
                  inactive={inactive}
                  key={inactive?.id}
                  setList={setList}
                  getAgencies={getAgencies}
                  setCurrentItem={setCurrentItem}
                  setCreateModalStatus={setCreateModalStatus}
                  setDeleteModal={setDeleteModal}
                  currentItem={currentItem}
                  corporateData={corporateListData}
                />
              ))
            ) : (
              <div className='corporate__table-empty'>
                <img src='/assets/no-data-v3.svg' alt='empty' />
                <p>{t('agencyInactive.messages.noData')}</p>
              </div>
            )}
          </div>
          <CustomPaginate
            pageCount={getAgencyData?.pages}
            handlePageClick={handlePageClick}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default AgencyInactive;
